'use strict';

var React = require('react');

var SvgThemeEditIcon = function SvgThemeEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 3.5a3.75 3.75 0 0 0-3.75 3.75v5.5a3.75 3.75 0 0 0 3.75 3.75h1a.75.75 0 0 0 0-1.5h-1a2.25 2.25 0 0 1-2.25-2.25v-3.25h5.5v2.75a.75.75 0 0 0 1.5 0v-7.25h.75a2.25 2.25 0 0 1 2.25 2.25v1a.75.75 0 0 0 1.5 0v-1a3.75 3.75 0 0 0-3.75-3.75h-5.5Zm3.25 1.5v3h-5.5v-.75a2.25 2.25 0 0 1 2.25-2.25h3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.03 12.371a.5.5 0 0 0 0-.707l-1.06-1.06a.5.5 0 0 0-.708 0l-.957.957 1.768 1.767.957-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.366 14.035-1.768-1.767-2.45 2.449a2 2 0 0 0-.585 1.407l-.002.698a.25.25 0 0 0 .25.25l.698-.002a2 2 0 0 0 1.408-.586l2.449-2.449Z"
  }));
};
SvgThemeEditIcon.displayName = "ThemeEditIcon";

exports.SvgThemeEditIcon = SvgThemeEditIcon;
